<template>
	<div class="container" v-if="currentLive">
		<VideoHeader :live="currentLive" v-if="currentLive.type == 0 || currentLive.type == 1"></VideoHeader>
		<ImageHeader :live="currentLive" v-if="currentLive.type == 2"></ImageHeader>
		<div v-if="currentLive.type != 0">
			<ad v-show="id == 550"></ad>
			<Detail :id="currentLive.id" :title="currentLive.title" :description="currentLive.description" :avatar="currentLive.avatar" :username="currentLive.username" :startTime="currentLive.startTime" :endTime="currentLive.endTime" :tags="currentLive.tags" :address="currentLive.address" :liveUrl="currentLive.liveUrl">
			</Detail>
			<Group :current.sync="index" :lives="lives"></Group>
			<Commodity :id="currentLive.id"></Commodity>
			<Comments @selectComment="selectComment" :data="comments"></Comments>
		</div>
	</div>
</template>

<script>
	import VideoHeader from "./videoheader"
	import ImageHeader from "./imageheader"
	import Detail from "./detail"
	import Group from "./group"
	import Comments from "./comments"
	import Commodity from "./commodity"
	import ad from './ad'

export default {
		name: "Live",
		data() {
			return {
				id: this.$route.params.id,
				index: 0,
				lives: [],
				comments: [],
				guestComment: [],
				authComment: [],
				commentSize: 100,
				commentTimestamp: 0,
				guestCommentTimestamp: 0,
				authCommentTimestamp: 0,
				isBrowser: false,
				commentType: 0,
			}
		},
		computed: {
			currentLive() {
				let live = this.lives[this.index]
				if(live) {
					this.$bus.$emit("setTitle", {
						title: live.title,
						description: live.description,
						shareImage: live.poster
					})
				}
				return live
			}
		},
		components: {
			VideoHeader,
			ImageHeader,
			Detail,
			Group,
			Comments,
			Commodity,
			ad
		},
		methods: {
			selectComment(type) {
				this.commentType = type;
				this.getComments();
			},
			getLives() {
				let max_width = window.innerWidth.toString() > 1100 ? 1100 : window.innerWidth.toString();
				this.axios.get("/live/id/" + this.id).then(res => {
					this.lives = res.data.data.map(item => {
						return {
							id: item.id,
							url: item.status === 4 ? item.recordUrl : item.livePlayUrl,
							type: item.type,
							status: item.status,
							poster: item.faceUrl,
							title: item.subtitle,
							description: item.description,
							avatar: item.userNameImg,
							username: item.userName,
							startTime: item.startTime,
							endTime: item.endTime,
							tags: item.tags ? item.tags.split(",") : [],
							address: item.address,
							width: max_width,
							height: item.type == 0 ? window.screen.height.toString() : (max_width * (9 / 16)).toString(),
							festival: item.festival,
							liveUrl: item.liveUrl
						}
					})
				})
			},
			getComments() {
				this.comments.length=0;
				this.axios.get("/liveComment/list", {
					params: {
						page: 1,
						limit: this.commentSize,
						liveId: this.id,
						timestamp: this.commentType == 0 ? this.authCommentTimestamp : this.guestCommentTimestamp,
						type: this.commentType
					}
				}).then((res) => {
					this.commentSize = 10
					res.data.data.forEach(item => {
						if(this.commentType == 0) {
							if(item.timestamp > this.authCommentTimestamp) {
								this.authCommentTimestamp = item.timestamp;
							}
							this.authComment.push({
								id: item.id,
								liveId: item.liveId,
								avatar: item.faceUrl,
								username: item.userName,
								grade: item.grade,
								createTime: item.createTime,
								context: item.text,
								address: item.area,
								images: item.picturesUrl ? item.picturesUrl.split(",") : [],
								video: {
									url: item.videourl,
									poster: item.videoimg,
								}
							})
						}
						else{
							if(item.timestamp > this.guestCommentTimestamp) {
								this.guestCommentTimestamp = item.timestamp;
							}
							this.guestComment.push({
								id: item.id,
								liveId: item.liveId,
								avatar: item.faceUrl,
								username: item.userName,
								grade: item.grade,
								createTime: item.createTime,
								context: item.text,
								address: item.area,
								
							})
							
						}
					})
					if(this.commentType===0){
						this.authComment.forEach(item=>{
							this.copeDate(item);
						})
					}
					else{
						this.guestComment.forEach(item=>{
							this.copeDate(item);
						})
					}
				});
			},
			copeDate(item){
				this.comments.push(item);
			},
		},
		mounted() {
			this.isBrowser = navigator.userAgent.toLowerCase().indexOf('micromessenger') != -1 ? true : false;
			this.getLives()
			this.getComments()
			setInterval(this.getComments, 60 * 1000)
		}
	}
</script>

<style lang="less" scoped>
	.container {
		padding: 0 auto;
		max-width: 1100px;
	}
</style>